import { all } from 'redux-saga/effects';

import anamneseSaga from './anamnese/saga';

export default all([anamneseSaga]);
